var Quality = {
	node :null,
	current: 2048,

	init: function() {
		Quality.node = $("<div id='qty'></div>");
		Quality.node.append(TPL.render("quality-main", {}));
		$("#overlay").append(Quality.node);

		if (Screen.xs()) Quality.toggle();

		$("#qty a").prop("title", TPL.lng("tips.clicktochangeqality", "Kliknij aby zmienić jakość"));

		AppEvent.on(player, "placeReady", function(pe) { Quality.placeReady(pe);});
	},

	placeReady: function(pe) {
		//$("#quality-main a").prop("title", TPL.lng("tips.clicktochangequality"), "Kliknij aby zmienić jakość");

		if (player.current.place_type == "panorama") { //  || player.current.place_type == "photo"
			$("#qty").show();
		} else {
			$("#qty").hide();
		}
	},

	toggle: function(event) {
		if (event) event.preventDefault();

		if (Quality.current == 2048) {
			Quality.current = 1280;
			Quality.node.find("a").html("SD");
			player.go(player.ident, player.dir);
		} else {
			Quality.current = 2048;
			Quality.node.find("a").html("HD");
			player.go(player.ident, player.dir);
		}
	}
}

PluginManager.add(Quality);